<template>
  <div style="text-align: center;">
    <div style="width: 75%;text-align: right;">
      <div >
      <span> 旧 密 码 ： </span>
      <el-input style="width: 50%;" type="password" v-model="password" autocomplete="off" placeholder="请输入旧密码"></el-input>
    </div>
    <div style="margin-top:15px">
      <span> 新 密 码 ： </span>
      <el-input style="width: 50%;" type="password" v-model="newPassword" autocomplete="off" placeholder="请输入新密码"></el-input>
    </div>
    <div style="margin-top:15px">
      <span> 确定新密码： </span>
      <el-input style="width: 50%;" type="password" v-model="newPassword1" autocomplete="off" placeholder="请输入新密码"></el-input>
    </div>
    
    </div>
    <el-button style="margin-top:20px" class='btn' type="primary" @click="determine()">确定</el-button>
  </div>
</template>
<script>
	import { userchange_pwd,productList } from '@/axios/api.js'
	export default {
		data() {
			return {
        password:'',
        newPassword:'',
        newPassword1:''
			}
		},
		methods: {
			determine() {
        if(this.newPassword.length < 8) {
          this.$message({
                    showClose: true,
                    message: '密码长度需为8位以上',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
                return
        }
        if(this.newPassword != this.newPassword1) {
          this.$message({
                    showClose: true,
                    message: '请检查密码',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
                return
        }
        var obj = {
          oldpwd:this.password, //旧密码
          newpwd:this.newPassword//新密码
        }
        userchange_pwd(obj).then((res=>{
          if(res.data.code == 100000) {
            this.$message({
                    showClose: true,
                    message: '未知错误',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
          }else if(res.data.code == 100100) {
            this.$message({
                    showClose: true,
                    message: '用户不存在',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
          }else if(res.data.code == 200026) {
            this.$message({
                    showClose: true,
                    message: '密码无效',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
          }else if(res.data.code == 200027) {
            this.$message({
                    showClose: true,
                    message: '修改密码失败',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
          }else if(res.data.code == 200016) {
            this.$message({
                    showClose: true,
                    message: '内部错误',
                    type: 'error',
                    center: true,
                    offset: 200,
                    duration: 2000,
                    customClass: 'widthMessage'
                })
          }else if(res.data.code == 0) {
          	this.$message({
							message: '修改成功！',
							type: 'success'
						})
            productList({productGroup:'',name:'',start: 0,count: 12}).then((res)=>{
            })
          }
        }))
        console.log(this.newPassword)
        console.log(this.newPassword1)
      }
		},
		mounted() {
		}
	}
</script>

<style scoped="scoped">
/deep/.el-input {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/declassify.vue